import React, { useState } from "react";
import MobileAccessModal from "../components/MobileAccessModal";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { POPULAR_GAMES, PUZZLE_SKILL_GAMES, SOLITAIRE_GAMES } from "../data/gameData";

function GamesPage() {
  const navigate = useNavigate();
  const [showAccessModal, setShowAccessModal] = useState(false);

  const allGames = [
    { id: 1, title: "Katana Fruits", image: "/assets/gamescard/fruit-ninja.png", link: "https://thegameio.ng/katana-fruits/" },
    { id: 2, title: "Water Craft", image: "/assets/gamescard/watercraft.png", link: "https://thegameio.ng/watercraft-rush/" },
    { id: 3, title: "Penalty kicks", image: "/assets/gamescard/penaltykicks.png", link: "https://thegameio.ng/penalty-kicks/" },
    { id: 4, title: "Duck Shooter", image: "/assets/gamescard/duck-shooter.png", link: "https://thegameio.ng/duck-shooter/" },
    { id: 5, title: "Ultimate Swish", image: "/assets/gamescard/ultimate-swish.png", link: "https://thegameio.ng/ultimate-swish/" },
    { id: 6, title: "Marble Blast", image: "/assets/gamescard/marbleblast.png", link: "https://thegameio.ng/marbleblast/" },

    {
      id: 7,
      title: "Word Puzzle",
      image: "/assets/gamescard/word-puzzle.png",
      link: "https://thegameio.ng/word-puzzle/",
    },
    { id: 8, title: "Different Emoji", image: "/assets/gamescard/different-emoji.png", link: "https://thegameio.ng/emoji-difference/" },
    { id: 9, title: "Fruit Skill", image: "/assets/gamescard/stick-fruit.png", link: "https://thegameio.ng/fruit-skill/" },
    { id: 10, title: "Lucky Wheels", image: "/assets/gamescard/lucky-wheel.png", link: "https://thegameio.ng/luckywheels/" },
    { id: 11, title: "Urban Crosser", image: "/assets/gamescard/urban-crosser.png", link: "https://thegameio.ng/urban-crosser/" },
    { id: 12, title: "Guess The Quiz", image: "/assets/gamescard/guessquiz.png", link: "https://thegameio.ng/engaging-emoji/" },

    {
      id: 13,
      title: "Gear Madness",
      image: "/assets/gamescard/gear-madness.png",
      link: "https://thegameio.ng/gear-madness/",
    },
    { id: 14, title: "Traffic Racer", image: "/assets/gamescard/traffic-racer.png", link: "https://thegameio.ng/traffic-racer/", },
    { id: 15, title: "Aero Rush", image: "/assets/gamescard/aero-rush.png" },
    { id: 16, title: "Formula Rush", image: "/assets/gamescard/formula-rush.png", link: "https://thegameio.ng/formula-racing/", },
    { id: 17, title: "Roadmash Car", image: "/assets/gamescard/roadmash22.png", link: "https://thegameio.ng/roadmash-car/" },
    { id: 18, title: "Fastlanego", image: "/assets/gamescard/fast-lane.png" },

    {
      id: 19,
      title: "puzzle master",
      image: "/assets/gamescard/puzzle-master.png",
      link: "https://thegameio.ng/jigsaw-puzzle/",
    },
    { id: 20, title: "Genius", image: "/assets/gamescard/genius.png", link: "https://thegameio.ng/genius/", },
    { id: 21, title: "Sudoku", image: "/assets/gamescard/sudoku.png", link: "https://thegameio.ng/sudoku/", },
    { id: 22, title: "Slider Puzzle", image: "/assets/gamescard/sliderpuzzle.png", link: "https://thegameio.ng/slider-puzzle/", },
    { id: 23, title: "Spelling Challenge", image: "/assets/gamescard/spellingchllange.png", link: "https://thegameio.ng/spelling-challenge/", },
    { id: 24, title: "3D Maze", image: "/assets/gamescard/3dmaze.png", link: "https://thegameio.ng/3dmaze/", },
    {
      id: 25,
      title: "Neon Pong",
      image: "/assets/gamescard/neonpong.png",
      link: "https://thegameio.ng/ai-puzzle/",
    },
    { id: 26, title: "Connect Four Classic", image: "/assets/gamescard/connectfour.png", link: "https://thegameio.ng/connect-four-classic/", },
    { id: 27, title: "Archery Master", image: "/assets/gamescard/shooting.png", link: "https://thegameio.ng/shooting-game/", },
    { id: 28, title: "Water Sort", image: "/assets/gamescard/watersort.png", link: "https://thegameio.ng/water-sort-puzzle/", },
    { id: 29, title: "Color Spinner", image: "/assets/gamescard/color-spinner.png", link: "https://thegameio.ng/color-spinner/", },
    { id: 30, title: "Juicy Puzzle", image: "/assets/gamescard/juicy-puzzle.png", link: "https://thegameio.ng/juicy-puzzle/", },
    { id: 31, title: "tetris-evolution", image: "/assets/gamescard/tetris-evolution.png", link: "https://thegameio.ng/tetris-evolution/", },
    { id: 32, title: "Word Puzzle", image: "/assets/gamescard/word-puzzle.png", link: "https://thegameio.ng/word-puzzle.jpg/", },
    { id: 33, title: "Guess The Quezz", image: "/assets/gamescard/guessquiz.png", link: "https://thegameio.ng/engaging-emoji/", },
    ...SOLITAIRE_GAMES,
    ...POPULAR_GAMES,
  ];


  const handleGameClick = () => setShowAccessModal(true);

  const categories = [
    {
      title: "Trending Games",
      games: allGames.slice(0, 6),
      slug: "trending",
    },
    {
      title: "New Release",
      games: allGames.slice(6, 12),
      slug: "newrelease",
    },
    {
      title: "Racing",
      games: allGames.slice(12, 18),
      slug: "racing",
    },
    {
      title: "Mind-mining games",
      games: allGames.slice(18, 33),
      slug: "mindmining",
    },
    {
      title: "Solitaire Games",
      games: allGames.slice(33, 40),
      slug: "solitaire",
    },
    {
      title: "Popular",
      games: POPULAR_GAMES,
      slug: "Popular",
    },
    {
      title: "Puzzle/Skills",
      games: PUZZLE_SKILL_GAMES,
      slug: "puzzleSkills",
    },
  ];

  return (
    <div className="bg-[#181820] min-h-screen overflow-x-hidden">
      {showAccessModal && <MobileAccessModal
        onClose={() => setShowAccessModal(false)}
        onVerified={() => { setShowAccessModal(false); navigate("/play"); }}
      />}

      {/* ================= BANNER ================= */}
      <section
        className="relative h-[280px] sm:h-[340px] md:h-[420px] lg:h-[420px] w-full bg-cover bg-center"
        style={{ backgroundImage: "url('/assets/banner-about-bg.webp')" }}
      >
        {/* overlays */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-transparent z-10"></div>

        {/* center glow image */}
        <img
          src="/assets/game-banner-illus-2.png"
          alt="center illustration"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
          w-[180px] sm:w-[220px] md:w-[280px] opacity-50 z-20 hidden sm:block"
        />

        <div className="relative z-30 h-full flex items-center">
          <div className="max-w-[1400px] mx-auto w-full px-4 sm:px-6 lg:px-10">
            <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-6">

              {/* LEFT CONTENT */}
              <div className="text-white text-center md:text-left">

                <div className="relative inline-block">
                  <img
                    src="/assets/images/game-banner-illus-1.png"
                    alt="decoration"
                    className="absolute -left-[70px] top-1/2 -translate-y-1/2 w-[300px] hidden md:block"
                  />

                  <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mt-12 md:mt-16">
                    Games
                  </h2>
                </div>

                <div className="flex justify-center md:justify-start gap-2 text-sm text-gray-300 mt-3">
                  <span>Home</span>        
                  <span>Pages</span>           
                  <span className="text-yellow-400 font-semibold">Games</span>
                </div>
              </div>

              {/* RIGHT IMAGES */}
              <div className="relative hidden md:block h-[420px]">

                <img
                  src="/assets/game-banner-illus-4.webp"
                  alt="character"
                  className="absolute bottom-0 right-[180px] w-[180px] lg:w-[200px] drop-shadow-2xl"
                />

                <img
                  src="/assets/game-banner-illus-3.webp"
                  alt="trophy"
                  className="absolute bottom-[80px] right-[20px] w-[160px] lg:w-[180px] drop-shadow-xl"
                />
              </div>

            </div>
          </div>
        </div>
      </section>


      {/* ================= CATEGORIZED GAMES LIST ================= */}
      <div className="pt-14 pb-40">
        <div className="max-w-6xl mx-auto px-4">

          <h2 className="text-center text-4xl font-extrabold text-white mb-16 uppercase tracking-wider">
            Our <span className="text-yellow-500">Games</span>
          </h2>

          {categories.map((category, catIdx) => (
            <div key={catIdx} className="mb-16">
              {/* Category Header */}
              <div className="flex justify-between items-center mb-8 gap-4 flex-wrap">
                <div className="flex items-center gap-4 flex-grow">
                  <h3 className="text-2xl sm:text-3xl font-bold text-white uppercase tracking-wide">
                    {category.title === "Trending Games" ? (
                      <>
                        <span className="text-yellow-500">Trending</span> Games
                      </>
                    ) : category.title === "New Release" ? (
                      <>
                        <span className="text-yellow-500">New</span> Release
                      </>
                    ) : category.title === "Mind-mining games" ? (
                      <>
                        <span className="text-yellow-500">Mind-Mining</span> Games
                      </>
                    ) : category.title === "Solitaire Games" ? (
                      <>
                        <span className="text-yellow-500">Solitaire</span> Games
                      </>
                    ) : (
                      <>
                        <span className="text-yellow-500">{category.title}</span> Games
                      </>
                    )}
                  </h3>
                  <div className="h-[2px] bg-gradient-to-r from-yellow-500 to-transparent flex-grow rounded hidden sm:block"></div>
                </div>

                <div className="flex items-center gap-3">
                  <button className={`swiper-prev-${category.slug} btn-hover bg-[#3a3f5c] w-10 h-10 rounded-lg flex items-center justify-center`}>
                    <span><IoIosArrowBack size={18} color="#fff" /></span>
                  </button>
                  <button className={`swiper-next-${category.slug} btn-hover bg-[#3a3f5c] w-10 h-10 rounded-lg flex items-center justify-center`}>
                    <span><IoIosArrowForward size={18} color="#fff" /></span>
                  </button>
                </div>
              </div>

              {/* Swiper Slider */}
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation={{
                  prevEl: `.swiper-prev-${category.slug}`,
                  nextEl: `.swiper-next-${category.slug}`,
                }}
                autoplay={{ delay: 3500 + catIdx * 200, disableOnInteraction: false }}
                loop={category.games.length > 5}
                spaceBetween={20}
                breakpoints={{
                  0: { slidesPerView: 2, spaceBetween: 10 },
                  480: { slidesPerView: 2, spaceBetween: 12 },
                  640: { slidesPerView: 3, spaceBetween: 16 },
                  768: { slidesPerView: 3, spaceBetween: 20 },
                  1024: { slidesPerView: 4, spaceBetween: 20 },
                  1280: { slidesPerView: 5, spaceBetween: 20 },
                }}
                className="trending-swiper"
              >
                {category.games.map((res) => (
                  <SwiperSlide key={res.id}>
                    <div
                      className="group cursor-pointer flex flex-col h-full"
                      onClick={() => handleGameClick(res)}
                    >
                      <div className="rounded-xl border border-gray-800 hover:border-yellow-500 transition-all duration-300 bg-[#0f0f18] overflow-hidden">
                        <div className={category.slug === "solitaire" || category.slug === "Popular" || category.slug === "puzzleSkills" ? "w-full aspect-[9/10] flex items-center justify-center bg-black" : "w-full h-[120px] sm:h-[160px] md:h-[180px] lg:h-[200px] flex items-center justify-center bg-black"}>
                          <img
                            src={res.image}
                            alt={res.title}
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                          />
                        </div>
                      </div>

                      <h3 className="text-white font-[Roboto Mono] text-sm sm:text-base md:text-lg font-semibold mt-4 text-center">
                        {res.title}
                      </h3>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ))}

        </div>
      </div>

      {/* ================= BUTTON HOVER ================= */}
      <style>{`
        .btn-hover {
          position: relative;
          overflow: hidden;
        }
        .btn-hover::before,
        .btn-hover::after {
          content: "";
          position: absolute;
          left: 0;
          width: 100%;
          height: 50%;
          background: #249f22;
          transform: scaleX(0);
          transition: transform 0.35s ease;
          z-index: 0;
        }
        .btn-hover::before {
          top: 0;
          transform-origin: left;
        }
        .btn-hover::after {
          bottom: 0;
          transform-origin: right;
        }
        .btn-hover:hover::before,
        .btn-hover:hover::after {
          transform: scaleX(1);
        }
        .btn-hover span {
          position: relative;
          z-index: 1;
        }
      `}</style>
    </div>
  );
}

export default GamesPage;

